import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { LimitedFilteredRequest } from './FilteredRequest.js';
export var ExcelExportType;
(function (ExcelExportType) {
    ExcelExportType["Payments"] = "payments";
    ExcelExportType["Members"] = "members";
    ExcelExportType["Registrations"] = "registrations";
    ExcelExportType["Organizations"] = "organizations";
    ExcelExportType["ReceivableBalances"] = "receivable-balances";
    ExcelExportType["EventNotifications"] = "event-notifications";
    ExcelExportType["BalanceItems"] = "BalanceItems";
})(ExcelExportType || (ExcelExportType = {}));
export class ExcelSheetColumnFilter extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.category = null;
    }
}
__decorate([
    field({ decoder: StringDecoder })
], ExcelSheetColumnFilter.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], ExcelSheetColumnFilter.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true, optional: true })
], ExcelSheetColumnFilter.prototype, "category", void 0);
export class ExcelSheetFilter extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.name = '';
        this.columns = [];
    }
}
__decorate([
    field({ decoder: StringDecoder })
], ExcelSheetFilter.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 345 })
], ExcelSheetFilter.prototype, "name", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(ExcelSheetColumnFilter), version: 345, upgrade: (old) => old.map(id => ExcelSheetColumnFilter.create({ id, name: '' })) }),
    field({ decoder: new ArrayDecoder(StringDecoder) })
], ExcelSheetFilter.prototype, "columns", void 0);
/**
 * Which sheets and columns to include in the excel file
 */
export class ExcelWorkbookFilter extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.sheets = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(ExcelSheetFilter) })
], ExcelWorkbookFilter.prototype, "sheets", void 0);
export class ExcelExportRequest extends AutoEncoder {
}
__decorate([
    field({ decoder: LimitedFilteredRequest })
], ExcelExportRequest.prototype, "filter", void 0);
__decorate([
    field({ decoder: ExcelWorkbookFilter })
], ExcelExportRequest.prototype, "workbookFilter", void 0);
export class ExcelExportResponse extends AutoEncoder {
    constructor() {
        super(...arguments);
        /**
         * Contains a file id which can be used to download the file
         *
         * If this is null, the file will be sent via e-mail
         */
        this.url = null;
    }
}
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], ExcelExportResponse.prototype, "url", void 0);
//# sourceMappingURL=ExcelExportRequest.js.map